import { createPinia, setActivePinia } from 'pinia';
import { useConfigStore } from './config';
import { useCellGroupStore } from './modules/cellGroup';
import { useDashboardStore } from './modules/dashboard';
import { useRBCSlideStore } from './modules/RBCregion';

// Create a Pinia instance
const pinia = createPinia();

// Ensure pinia is active for stores created outside setup
setActivePinia(pinia);

export default pinia;
export { pinia };
export { useConfigStore, useCellGroupStore, useDashboardStore, useRBCSlideStore };
